import React, { FunctionComponent } from 'react';
import useWebframePermissions from '../hooks/useWebframePermissions';

type RequiresPermissionProps = {
  permission: string;
  children: React.ReactNode;
};

const RequiresPermission: FunctionComponent<RequiresPermissionProps> = ({
  permission,
  children,
}) => {
  const { isGranted } = useWebframePermissions();

  return <>{isGranted(permission) && children}</>;
};

export default RequiresPermission;
